import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Board from './Board';
import { Box, useTheme } from '@mui/material';
import { setWhiteBoardDimentions } from '../../../features/screenSharing/screenSharingSlice';


const Boards = () => {
    const theme = useTheme();
    const { panels } = useSelector((store) => store.tabs)
    const containerRef = useRef()
    const dispatch = useDispatch();

    useEffect(() => {
        let frameId;
        const updateDimensions = () => {
            cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(() => {
            if (!containerRef.current) {
                return;
            }
            const rect = containerRef.current.getBoundingClientRect();
            if (rect.width <= 0 || rect.height <= 0) return;
            dispatch(setWhiteBoardDimentions({
                dimensions: {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width, 
                    height: rect.height, 
                    fullWidth: window.innerWidth, 
                    fullHeight: window.innerHeight, 
                    PR: window.devicePixelRatio, 
                    dir: theme.direction, 
                    screenSharing: false 
                }
            }));
            });
        };
        const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(updateDimensions);
        if (containerRef.current) observer?.observe(containerRef.current);
        window.addEventListener('resize', updateDimensions);
        updateDimensions();
        return () => {
            cancelAnimationFrame(frameId);
            observer?.disconnect();
            window.removeEventListener('resize', updateDimensions);
        };
    }, [dispatch, theme.direction])

    return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 0, overflow: 'hidden' }}>
            <Box ref={containerRef} data-testid="board-content" sx={{ width: '100%', height: '100%', minHeight: 0, overflow: 'hidden' }}>
                {panels.map(panel => <Board key={panel.id} panel={panel} />)}
            </Box>
        </Box>

    )
}

export default Boards
